import { Type } from "@angular/core";
import { ActiveCartEffects } from "./active-cart.effects";
import { CreateCartEffects } from "./create-cart.effects";
import { CartEffects } from "./manage-carts-effects";
import { SharedManageCartsEffects } from "./shared-manage-carts.effect";

export const effects: Type<
  ActiveCartEffects | CartEffects | CreateCartEffects | SharedManageCartsEffects
>[] = [
    ActiveCartEffects,
    CartEffects,
    CreateCartEffects,
    SharedManageCartsEffects,
  ];